import styled from "styled-components";
import { responsive } from "../../../styles/constants.style";

export const BulkInsertHeaderWrapper = styled.div`
  margin: 4px 0px 16px;

  ${responsive.MOBILE`
    margin: 0;  
  `}

  .header-right {
    text-align: end;
    margin-top: 16px;

    ${responsive.MOBILE`
      margin-top: 0;
    `}
  }

  .header-center-button {
    ${responsive.MOBILE`
      margin-bottom: 16px;
      width: 100%;
    `}
  }
`;
